'use client';

import { Menu } from '@mui/material';

import { styled } from '../../styles';

export const SelectGhostMenu = styled(Menu)(() => ({
  '& .MuiPaper-root': {
    minWidth: 158,
    maxHeight: 160,
  },
}));

export const SelectItem = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  width: '100%',
}));

export const SelectItemLabel = styled.span(
  () =>
    ({
      flex: 1,
      textAlign: 'start',
    } as const),
);
